import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Breadcrumb} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  link: {
    external: boolean,
    targetLabelOrName: string,
    targetType: string,
    targetUid: string,
    title: string,
    uid: string,
    url: string
  },
  uid: string
}

interface BreadcrumbResponse {
  breadcrumbs: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/navigation/breadcrumbs?pageUid=';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite
  }

  private static transformFromApi(response: IResponseItem, pageUid: string): Breadcrumb {
    return {
      ...response,
      id: response.uid,
      page: pageUid
    };
  }

  getAll(pageUid: string): Observable<Breadcrumb[]> {
    return this.http.get<BreadcrumbResponse>(this.getOneUrl(pageUid)).pipe(
      map((response: BreadcrumbResponse) => response.breadcrumbs.map(
        (child: IResponseItem) => BreadcrumbConnectors.transformFromApi(child, pageUid)
      )),
      catchError(error => throwError(error))
    );
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(pageUid: string) {
    return this._rootUrl + this._baseSite + this.route + pageUid;
  }
}
